export default __webpack_public_path__ + "static/media/control-2.ab1a4609.webp";